<template>
    <div class="company_box">
        <div class="company_detial">
            <div class="search_box">
                <el-popover ref="searchPopperRef" placement="bottom-start" popper-class="job-search-popper" width="786" trigger="click">
                    <div class="job-type flex-center" slot="reference">
                        <span>职位类型</span>
                        <i class="el-icon-caret-bottom"></i>
                    </div>

                    <JobTypePopper @check="searchJob()"></JobTypePopper>
                </el-popover>

                <el-input class="search_input" placeholder="搜索职位、公司" v-model="searchValue"></el-input>
                <span
                    class="button"
                    @click="
                        () => {
                            if (searchValue.trim()) searchJob({ keyword: searchValue });
                        }
                    "
                >
                    搜索
                </span>
            </div>

            <div class="filter-box">
                <div class="filter-item" v-for="(item, key) in filterOptions" :key="key">
                    <div class="filter-item_label">{{ item.label }}</div>

                    <div class="filter-item_list">
                        <!-- 城市-其他城市 -->
                        <div class="option-item other-city active" v-if="key === 'city' && isOtherCity">
                            {{ filter.city }}
                        </div>

                        <div
                            :class="['option-item', { active: option.value === filter[key] }]"
                            v-for="option in item.options"
                            :key="option.value"
                            @click="handleCheckFilter(key, option.value)"
                        >
                            {{ option.label }}
                        </div>

                        <div class="option-item" v-if="key === 'city'" @click="handleCheckCity">全部城市</div>
                    </div>
                </div>

                <div class="clear" @click="clearFilter">清空筛选条件</div>
            </div>
        </div>

        <div class="company-box">
            <div class="company-list" v-if="companyList.length > 0">
                <div class="company-item" v-for="item in companyList" :key="item.id" @click="toCompanyDetail(item)">
                    <div class="company-item_info">
                        <img :src="item.logo" alt="" class="info-logo" />

                        <div class="info-main">
                            <div class="company-name ellipsis-single">{{ item.name }}</div>

                            <div class="company-tags">
                                <i class="tag" v-if="item.funding_stage">{{ item.funding_stage }}</i>
                                <i class="tag" v-if="item.industry">{{ item.industry }}</i>
                            </div>
                        </div>
                    </div>

                    <div class="company-item_job flex-center">
                        <span class="label">热招</span>

                        <div class="job-info flex-center">
                            <template v-if="item.position && item.position.length > 0">
                                <div class="info-name ellipsis-single" @click="toJobDetail(item.position[0])">
                                    {{ item.position[0].name }}
                                </div>
                                <div class="info-salary">{{ item.position[0].salary }}</div>
                            </template>

                            <span style="color: #666666" v-else>无</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="company-empty flex-center" v-else>
                <img src="@/assets/img/company/company-empty.png" alt="" />
                <span>暂时没有符合要求的公司</span>
                <span>您可以去浏览下<i @click.stop="$router.push({ path: '/student/recruitmentCenter/job' })">职位</i></span>
            </div>
        </div>

        <CityCheckDialog
            v-model="cityVisible"
            :check="filter.city"
            @check="
                ($event) => {
                    filter.city = $event.value;
                    getCompanyList(false);
                }
            "
        ></CityCheckDialog>
    </div>
</template>

<script>
import cityJSON from "@/json/city.json";
import CityCheckDialog from "@/components/recruitmentCenter/job/CityCheckDialog.vue";
import JobTypePopper from "../../../../components/recruitmentCenter/components/JobTypePopper.vue";

export default {
    name: "Company",
    data() {
        return {
            scrollContainer: undefined,
            cityVisible: false,
            searchValue: "",
            companyList: [],
            pageParams: {
                page: 1,
                page_size: 200,
                total: 0,
            },
            filter: {
                city: "全国",
                industry: "不限",
                staff_size: "不限",
            },
            filterOptions: {
                city: {
                    label: "公司地点：",
                    options: cityJSON.hotCityList,
                },
                industry: {
                    label: "行业类型：",
                    options: [
                        { label: "不限", value: "不限" },
                        { label: "电子商务", value: "电子商务" },
                        { label: "游戏", value: "游戏" },
                        { label: "社交网络与媒体", value: "社交网络与媒体" },
                        { label: "广告营销", value: "广告营销" },
                        { label: "大数据", value: "大数据" },
                        { label: "医疗健康", value: "医疗健康" },
                        { label: "生活服务(O2O)", value: "生活服务(O2O)" },
                        { label: "O2O", value: "O2O" },
                        { label: "旅游", value: "旅游" },
                        { label: "分类信息", value: "分类信息" },
                        { label: "音乐/视频/阅读", value: "音乐/视频/阅读" },
                        { label: "在线教育", value: "在线教育" },
                        { label: "社交网络", value: "社交网络" },
                        { label: "人力资源服务", value: "人力资源服务" },
                        { label: "企业服务", value: "企业服务" },
                        { label: "信息安全", value: "信息安全" },
                        { label: "智能硬件", value: "智能硬件" },
                        { label: "移动互联网", value: "移动互联网" },
                        { label: "互联网", value: "互联网" },
                        { label: "计算机软件", value: "计算机软件" },
                        { label: "通信/网络设备", value: "通信/网络设备" },
                        { label: "广告/公关/会展", value: "广告/公关/会展" },
                        { label: "互联网金融", value: "互联网金融" },
                        { label: "物流/仓储", value: "物流/仓储" },
                        { label: "进出口贸易", value: "进出口贸易" },
                        { label: "咨询", value: "咨询" },
                        { label: "工程施工", value: "工程施工" },
                        { label: "汽车研发/制造", value: "汽车研发/制造" },
                        { label: "其他行业", value: "其他行业" },
                    ],
                },
                staff_size: {
                    label: "公司规模：",
                    options: [
                        { label: "不限", value: "不限" },
                        { label: "0-20人", value: "0-20人" },
                        { label: "20-99人", value: "20-99人" },
                        { label: "100-499人", value: "100-499人" },
                        { label: "500-999人", value: "500-999人" },
                        { label: "1000-9999人", value: "1000-9999人" },
                        { label: "10000人以上", value: "10000人以上" },
                    ],
                },
            },
        };
    },

    components: { CityCheckDialog, JobTypePopper },

    computed: {
        filterParams() {
            const params = {};

            if (this.filter.city !== "全国") params.city = this.filter.city;
            if (this.filter.industry !== "不限") params.industry = this.filter.industry;
            if (this.filter.staff_size !== "不限") params.staff_size = this.filter.staff_size;

            return params;
        },

        // 是否是其他城市而不是热门城市
        isOtherCity() {
            const hotCityList = this.filterOptions.city.options.map((item) => item.value);

            return !hotCityList.includes(this.filter.city);
        },
    },

    mounted() {
        this.getCompanyList(false);

        this.scrollContainer = document.querySelector(".right-wrapper.el-scrollbar .el-scrollbar__wrap");
        this.scrollContainer?.addEventListener("scroll", this.scrollListener);
    },

    beforeDestroy() {
        this.scrollContainer?.removeEventListener("scroll", this.scrollContainer);
    },

    methods: {
        // 搜索
        searchJob(query = {}) {
            this.$refs.searchPopperRef?.doClose?.();

            const href = this.$router.resolve({
                path: "/student/recruitmentCenter/job",
                query: query,
            }).href;

            localStorage.removeItem("defaultActive");
            window.open(href, "_blank");
        },

        getCompanyList(add = true) {
            const params = {
                page: this.pageParams.page,
                page_size: this.pageParams.page_size,
                ...this.filterParams,
            };

            this.$httpStudent.axiosGetBy(this.$api.jobCompanyList, params, (res) => {
                if (res.code === 200) {
                    if (add) {
                        this.companyList.push(...(res.data?.list || []));
                    } else {
                        this.companyList = res.data?.list || [];
                    }

                    this.pageParams.total = res.data?.total || 0;
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 清空过滤
        clearFilter() {
            this.filter = {
                city: "全国",
                industry: "不限",
                staff_size: "不限",
            };
            this.pageParams.page = 1;

            this.getCompanyList(false);
        },

        // 过滤
        handleCheckFilter(key, value) {
            this.filter[key] = value;
            this.pageParams.page = 1;

            this.getCompanyList(false);
        },

        // 选择城市
        handleCheckCity() {
            this.cityVisible = true;
        },

        // 跳转职位详情
        toJobDetail(job) {
            this.$router.push({
                path: "/student/recruitmentCenter/job/detail",
                query: { id: job.position_id },
            });
        },

        // 查看公司详情
        toCompanyDetail(company) {
            this.$router.push({
                path: "/student/recruitmentCenter/companyDetial",
                query: { id: company.id },
            });
        },

        scrollListener(e) {
            const target = e.target;
            const distance = 50;
            const isToBottom = target.scrollTop >= target.scrollHeight - target.clientHeight - distance;
            const isMore = this.pageParams.page * this.pageParams.page_size < this.pageParams.total;

            if (isToBottom && isMore) {
                this.pageParams.page += 1;
                this.getCompanyList();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.company_box {
    width: 100%;

    * {
        box-sizing: border-box;
    }

    .company_detial {
        width: 100%;
        padding: 24px 268px 22px 257px;
        background: #ffffff;
        margin-bottom: 16px;

        .search_box {
            display: flex;
            height: 54px;
            align-items: center;
            border-radius: 8px;
            border: 2px solid #685ef5;
            margin-right: 274px;

            .job-type {
                margin-left: 20px;
                cursor: pointer;

                span {
                    white-space: nowrap;
                    font-weight: 500;
                    font-size: 16px;
                    color: #222222;
                }

                .el-icon-caret-bottom {
                    color: #9fa3af;
                    margin: 0 8px;
                }

                &:hover {
                    span,
                    i {
                        color: #685ef5;
                    }
                }
            }

            .search_input {
                ::v-deep .el-input__inner {
                    border: none;
                }
            }

            .button {
                width: 118px;
                height: 54px;
                flex-shrink: 0;
                font-weight: 500;
                font-size: 20px;
                background: #685ef5;
                border-radius: 0px 4px 4px 0px;
                display: flex;
                color: #ffffff;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }

        .filter-box {
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin-top: 16px;
            position: relative;

            .filter-item {
                display: flex;
                gap: 8px;

                &_label {
                    flex-shrink: 0;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 20px;
                    color: #222229;
                }

                &_list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 4px 20px;

                    .option-item {
                        font-weight: 400;
                        font-size: 14px;
                        color: #222222;
                        line-height: 20px;
                        cursor: pointer;

                        &.active {
                            color: #685ef5;
                        }
                    }
                }
            }

            .clear {
                position: absolute;
                right: 0;
                bottom: 0;
                font-weight: 400;
                font-size: 14px;
                color: #9fa19f;
                cursor: pointer;

                &:hover {
                    color: #685ef5;
                }
            }
        }
    }

    .company-box {
        padding-inline: 257px;

        .company-list {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 16px;

            .company-item {
                min-width: 0;
                border-radius: 10px;
                overflow: hidden;
                // height: 1800px;
                // border: 1px solid #222222;

                &_info {
                    padding: 22px;
                    background-color: #ffffff;
                    display: flex;
                    gap: 13px;

                    .info-logo {
                        width: 54px;
                        height: 54px;
                        background: #d7d7d7;
                        border-radius: 8px;
                        object-fit: cover;
                    }

                    .info-main {
                        flex: 1;
                        min-width: 0;

                        .company-name {
                            font-weight: 500;
                            font-size: 16px;
                            color: #222222;
                            margin-bottom: 10px;
                        }

                        .company-tags {
                            .tag {
                                background: #f8f8f8;
                                border-radius: 4px;
                                font-style: normal;
                                padding: 2px 8px;
                                font-weight: 400;
                                font-size: 13px;
                                color: #222222;

                                & + .tag {
                                    margin-left: 8px;
                                }
                            }
                        }
                    }
                }

                &_job {
                    padding: 14px 22px;
                    background-color: #f8fcfb;
                    justify-content: flex-start;
                    font-size: 13px;

                    .label {
                        font-weight: 400;
                        font-size: 14px;
                        color: #747474;
                        margin-right: 8px;
                        padding-right: 8px;
                        display: inline-block;
                        position: relative;

                        &::after {
                            content: "";
                            position: absolute;
                            top: 50%;
                            right: 0;
                            width: 1px;
                            height: 70%;
                            transform: translateY(-50%);
                            background-color: #e0e0e0;
                        }
                    }

                    .job-info {
                        flex: 1;
                        min-width: 0;
                        gap: 4px;
                        justify-content: flex-start;

                        .info-name {
                            flex: 1;
                            min-width: 0;
                            font-weight: 400;
                            font-size: 14px;
                            color: #685ef5;
                            cursor: pointer;
                        }

                        .info-salary {
                            font-weight: 400;
                            font-size: 13px;
                            color: #666666;
                        }
                    }
                }
            }
        }

        .company-empty {
            flex-direction: column;
            background-color: #ffffff;
            border-radius: 12px;
            padding-block: 150px;
            gap: 3px;

            img {
                width: 200px;
                object-fit: cover;
                margin-bottom: 8px;
            }

            span {
                color: #9fa19f;
                font-size: 12px;
            }

            i {
                cursor: pointer;
                font-style: normal;
                color: #685ef5;
            }
        }
    }
}
</style>

<style lang="scss">
.job-search-popper {
    padding: 0;
    border: none;
    background-color: transparent;
    box-shadow: none;

    .popper__arrow {
        display: none;
    }
}
</style>
